import React from "react";
import {CustomSocket} from "./CustomSocket";
import {NODE_INPUT_MARGIN_LEFT} from "../../stylingConstants";
import styled from '@emotion/styled';

const StyledInputContainerDiv = styled.div`
  margin-left: ${NODE_INPUT_MARGIN_LEFT};
  align-self: center;
`;

export const Input = ({input, bindSocket}) => {
    return(
        <StyledInputContainerDiv>
            <CustomSocket type="input" socket={input.socket} io={input} innerRef={bindSocket} />
        </StyledInputContainerDiv>
    );
}

export default Input;